import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Modal from '../component/Modal';
import Button from '../component/Button';

function LoginPage() {
  const navigate = useNavigate();
  const { handleSignIn } = useAuth();
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = (event) => {
    setLoading(true);
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    handleSignIn(
      name,
      () => {
        navigate('/');
      },
      (error) => {
        setError('Invalid name: ' + error);
        setLoading(false);
      }
    );
  };

  return (
    <div className="page login">
      <Modal show={true} onClose={() => {}} className="rsvp">
        <div className="modal-contents">
          <h1>{loading ? 'ENTERING...' : 'WELCOME!'}</h1>
          <form onSubmit={onSubmit}>
            <div className="form-section pixel-corners-wrapper">
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                disabled={loading}
                placeholder="NAME"
                className="pixel-corners"
              />
            </div>
            <p style={{ color: 'red' }}>{error}</p>
            <div className="form-section submit-button-wrapper">
              <Button
                type="submit"
                className="submit pixel-corners green"
                disabled={loading}
                onClick={onSubmit}
              >
                ENTER
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default LoginPage;
